/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupCollaboratorDtoPage } from '../../models/group-collaborator-dto-page';

export interface ListGroupCollaborators$Params {
  groupId: string;
  userId?: string | null;
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'firstName' | '-firstName' | 'lastName' | '-lastName' | 'color' | '-color' | 'email' | '-email' | 'phoneNumber' | '-phoneNumber'>;
}

export function listGroupCollaborators(http: HttpClient, rootUrl: string, params: ListGroupCollaborators$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupCollaboratorDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listGroupCollaborators.PATH, 'get');
  if (params) {
    rb.query('groupId', params.groupId, {});
    rb.query('userId', params.userId, {});
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupCollaboratorDtoPage>;
    })
  );
}

listGroupCollaborators.PATH = '/v0/groups/group-collaborators';
